import { Button, Flex, Grid, Icon } from '@pega/cosmos-react-core';
import React, { useState } from 'react';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { InteractiveText } from '../../../Utilities/custom.styled';
import CustomerTranscriptAndDetails from './CustomerTranscriptAndDetails';

export interface SimulationDetailsProps {
  simulationData: any;
  setShowCustomerDetails: any;
  csvFile: any;
  createCsv: (id: string) => void;
}

const SimulationMetricsDetails: React.FC<SimulationDetailsProps> = ({
  simulationData,
  setShowCustomerDetails,
  csvFile,
  createCsv,
}) => {
  const translate = useLocalTranslation();

  const selectedSimulationData = simulationData;
  const customers = selectedSimulationData?.customers;
  const [selectedCustomer, setSelectedCustomer] = useState<any>({});

  const handleClick = () => {
    setShowCustomerDetails(false);
  };

  return (
    <>
      <Grid
        container={{
          cols: '2fr 2fr ',
          colGap: 2,
        }}
        style={{ marginBottom: '1rem' }}
      >
        <Flex>
          <InteractiveText className="pointer" onClick={handleClick}>
            <Icon name="arrow-left" />
            {` ${translate('back')}`}
          </InteractiveText>
        </Flex>
        <Flex
          container={{
            direction: 'column',
            alignItems: 'end',
          }}
        >
          <Button
            href={`data:text/csv;charset=utf-8,${csvFile}`}
            download={`Simulation-history-${simulationData.simulationId}.csv`}
            onClick={() => {
              createCsv(simulationData.simulationId);
            }}
            variant="link"
          >
            <Icon name="download" />
            {translate('download_csv_file')}
          </Button>
        </Flex>
      </Grid>
      {customers?.length > 0 && (
        <CustomerTranscriptAndDetails
          customerData={customers}
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
        />
      )}
    </>
  );
};

export default SimulationMetricsDetails;
